import { apiClient, unwrap } from '@services/api';
import type { Order, OrderStatus, OrderType } from '@/types';

export interface CreateOrderPayload {
  wholesalerId: string;
  items: { productId: string; quantity: number }[];
  orderType: OrderType;
  note?: string;
}

export const orderService = {
  async getOrders(): Promise<Order[]> {
    const res = await apiClient.get<Order[]>('/orders');
    return unwrap(res);
  },

  async getOrder(id: string): Promise<Order> {
    const res = await apiClient.get<Order>(`/order-details/${id}`);
    return unwrap(res);
  },

  async createOrder(payload: CreateOrderPayload): Promise<Order> {
    const res = await apiClient.post<Order>('/orders', payload);
    return unwrap(res);
  },

  async updateStatus(orderId: string, status: OrderStatus): Promise<void> {
    await apiClient.post('/orders/status', { orderId, status });
  },

  async checkNewOrders(since?: string): Promise<{ count: number; orders: Order[] }> {
    const res = await apiClient.get<{ count: number; orders: Order[] }>(
      '/wholesaler/check-new-orders',
      { params: since ? { since } : undefined },
    );
    return unwrap(res);
  },
};
